import * as React from 'react';
import * as styles from './styles.css';
import { UIHeading2 } from '@cian/ui-kit';

interface IPurchaseItemProps {
  title: string;
  step: number;
}

import icon from './assets/ArrowUpRight.svg';

export function PurchaseItem({ step, title }: IPurchaseItemProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['header']}>
        <span className={styles['step']}>{step}</span>
        <span className={styles['arrow']}>
          <img src={icon} alt="icon" />
        </span>
      </div>
      <div className={styles['title']}>
        <UIHeading2>{title}</UIHeading2>
      </div>
    </div>
  );
}
